import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV || 'development',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? '0') || 0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error }) => (
    <div style={{ padding: 24, textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h1>Something went wrong</h1>
      <p>{error instanceof Error ? error.message : 'An unexpected error occurred.'}</p>
      <button type="button" onClick={() => window.location.reload()}>
        Reload page
      </button>
    </div>
  ),
  showDialog: false,
});

root.render(
  <React.StrictMode>
    <SentryApp />
  </React.StrictMode>
);

